import React, { useMemo } from 'react'
import HeroCard from 'src/components/common/HeroCard'
import PPVTemplate from 'src/components/page/ppv'
import { typographyMixin } from 'src/constants/marketing-ds/typography'
import styled from 'styled-components'
import { body } from 'src/constants/marketing-ds/typography'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { useSelector } from 'react-redux'
import { fireUIInteractionEvent } from 'src/modules/analytics/v3'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { WEB_MARKETING_PPV_UEFA_WCQ } from 'src/modules/reducers/cohorts/constants'
import { colors } from 'src/constants/marketing-ds'

const PPV_UEFA_WCQ_FLAGS = {
  default: 'default', //default flag
  nov_1: 'nov_1', //set to schedule oct 31 at 11:59PM ET
  nov_7: 'nov_7', // set to schedule nov 6 at 11:59PM ET
  nov_14: 'nov_14', // set to schedule nov 13 at 11:59PM ET
  nov_15: 'nov_15', // set to schedule nov 14 at 11:59PM ET
  nov_16: 'nov_16', // set to schedule nov 15 at 11:59PM ET
  nov_17: 'nov_17', // set to schedule nov 16 at 11:59PM ET
  none: 'none', // set to schedule nov 18 at 11:59PM ET
}

const ppvPromoCodes = {
  // TODO: add promo codes
  ppv_uefa_ireland_v_portugal: 'us-rc-ga-irl_v_port-251113-ppv-1',
  ppv_uefa_poland_v_netherlands: 'us-rc-ga-pol_v_nlds-251114-ppv-2',
  ppv_uefa_georgia_v_spain: 'us-rc-ga-ga_v_esp-251115-ppv-3',
  ppv_uefa_albania_v_england: 'us-rc-ga-alb_v_eng-251116-ppv-4',
  ppv_uefa_spain_v_turkiye: 'us-rc-ga-esp_v_tur-251118-ppv-5',
  ppv_uefa_all_matches: 'us-rc-ga-uefa_pass-251113_18-ppv-1',
  ppv_uefa_early_bird: 'us-rc-ga-mvp_access_uefa_pass-251113_18-ppv-1',
}

const prices = {
  all_matches: 24.99,
  early_bird: 19.99,
  single_match: 9.99,
}

export default (props) => {
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const flagValue = useCohortFlag(WEB_MARKETING_PPV_UEFA_WCQ)

  const ppvEvents = useMemo(
    () =>
      [
        {
          thumbnail: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/ppv-banner-tile.png',
          flags: [
            PPV_UEFA_WCQ_FLAGS.nov_1,
            PPV_UEFA_WCQ_FLAGS.nov_7,
            PPV_UEFA_WCQ_FLAGS.nov_14,
            PPV_UEFA_WCQ_FLAGS.nov_15,
            PPV_UEFA_WCQ_FLAGS.nov_16,
          ],
          id: 6,
          title: 'All Matches',
          ratePlanCode:
            flagValue === PPV_UEFA_WCQ_FLAGS.nov_1
              ? ppvPromoCodes.ppv_uefa_early_bird
              : ppvPromoCodes.ppv_uefa_all_matches,
          hideMeta: true,
          price: flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? prices.early_bird : prices.all_matches,
          isAllMatches: true,
        },
        {
          text: 'Ireland v Portugal (11/13)',
          flags: [PPV_UEFA_WCQ_FLAGS.nov_1, PPV_UEFA_WCQ_FLAGS.nov_7],
          available: true,
          purchasable: flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? false : true,
          id: 1,
          title: 'Ireland v Portugal',
          thumbnail:
            'https://assets-imgx.fubo.tv/marketing/lp/images/teams/uefa/ireland-vs-portugal.png',
          channel: 'Pay Per View 1',
          date: '11/13',
          time: '2:45 PM ET',
          ratePlanCode: ppvPromoCodes.ppv_uefa_ireland_v_portugal,
          price: prices.single_match,
        },
        {
          text: 'Poland v Netherlands (11/14)',
          flags: [PPV_UEFA_WCQ_FLAGS.nov_1, PPV_UEFA_WCQ_FLAGS.nov_7, PPV_UEFA_WCQ_FLAGS.nov_14],
          available: true,
          purchasable: flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? false : true,
          id: 2,
          title: 'Poland v Netherlands',
          thumbnail:
            'https://assets-imgx.fubo.tv/marketing/lp/images/teams/uefa/poland-vs-netherlands.png',
          channel: 'Pay Per View 2',
          date: '11/14',
          time: '2:45 PM ET',
          ratePlanCode: ppvPromoCodes.ppv_uefa_poland_v_netherlands,
          price: prices.single_match,
        },
        {
          text: 'Georgia v Spain (11/15)',
          flags: [
            PPV_UEFA_WCQ_FLAGS.nov_1,
            PPV_UEFA_WCQ_FLAGS.nov_7,
            PPV_UEFA_WCQ_FLAGS.nov_14,
            PPV_UEFA_WCQ_FLAGS.nov_15,
          ],
          available: true,
          purchasable: flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? false : true,
          id: 3,
          title: 'Georgia v Spain',
          thumbnail:
            'https://assets-imgx.fubo.tv/marketing/lp/images/teams/uefa/georgia-vs-spain.png',
          channel: 'Pay Per View 3',
          date: '11/15',
          time: '2:45 PM ET',
          ratePlanCode: ppvPromoCodes.ppv_uefa_georgia_v_spain,
          price: prices.single_match,
        },
        {
          text: 'Albania v England (11/16)',
          flags: [
            PPV_UEFA_WCQ_FLAGS.nov_1,
            PPV_UEFA_WCQ_FLAGS.nov_7,
            PPV_UEFA_WCQ_FLAGS.nov_14,
            PPV_UEFA_WCQ_FLAGS.nov_15,
            PPV_UEFA_WCQ_FLAGS.nov_16,
          ],
          available: true,
          purchasable: flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? false : true,
          id: 4,
          title: 'Albania v England',
          thumbnail:
            'https://assets-imgx.fubo.tv/marketing/lp/images/teams/uefa/albania-vs-england.png',
          channel: 'Pay Per View 1',
          date: '11/16',
          time: '2:45 PM ET',
          ratePlanCode: ppvPromoCodes.ppv_uefa_albania_v_england,
          price: prices.single_match,
        },
        {
          text: 'Spain v Turkey (11/18)',
          flags: [
            PPV_UEFA_WCQ_FLAGS.nov_1,
            PPV_UEFA_WCQ_FLAGS.nov_7,
            PPV_UEFA_WCQ_FLAGS.nov_14,
            PPV_UEFA_WCQ_FLAGS.nov_15,
            PPV_UEFA_WCQ_FLAGS.nov_16,
            PPV_UEFA_WCQ_FLAGS.nov_17,
          ],
          available: true,
          purchasable: flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? false : true,
          id: 5,
          title: 'Spain v Turkey',
          thumbnail:
            'https://assets-imgx.fubo.tv/marketing/lp/images/teams/uefa/spain-vs-turkey.png',
          channel: 'Pay Per View 2',
          date: '11/18',
          time: '2:45 PM ET',
          ratePlanCode: ppvPromoCodes.ppv_uefa_spain_v_turkiye,
          price: prices.single_match,
        },
      ].filter((event) => event.flags.includes(flagValue)),
    [flagValue]
  )

  const isFlagNone = flagValue === 'none'
  const isFlagLastMatch = flagValue === PPV_UEFA_WCQ_FLAGS.nov_17
  const isFlagNoneOrLastMatch = flagValue === 'none' || isFlagLastMatch
  const lastMatchRatePlanCode = ppvPromoCodes.ppv_uefa_spain_v_turkiye

  const handleOnClick = () => {
    fireUIInteractionEvent(
      {
        element: 'Buy one match for $9.99',
        component: 'hero_card_cta',
        type: 'click',
      },
      stateForProtobuf
    )
  }

  return (
    <PPVTemplate
      lang="en"
      market="us"
      location={props.location}
      offerCode={isFlagLastMatch ? lastMatchRatePlanCode : ppvPromoCodes.ppv_uefa_all_matches}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/LP_PPV_CONCACAF_WCQ.mp4'}
      title="Exclusive UEFA World Cup Qualifiers"
      subtitle={`Watch Portugal, Spain, England and more in the 2026 World Cup qualifiers with Pay Per View`}
      additionalFAQs={additionalFAQs}
      platformImage="https://assets-imgx.fubo.tv/marketing/lp/images/devices/ca-devices-2025.png"
      pageDescription="Watch Portugal, Spain, England and more in the 2026 World Cup qualifiers with Pay Per View"
      heroSideComponent={
        ppvEvents.length > 0 && !isFlagNoneOrLastMatch ? (
          <HeroCard
            title={
              flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? (
                <>
                  Buy now and save 25% with <span className="no-wrap">MVP Access!</span>
                </>
              ) : (
                'Save 50% when you buy all matches'
              )
            }
            ctaText={
              flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? 'All matches $19.99' : 'All matches $24.99'
            }
            listItems={ppvEvents}
            footnote={
              flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? (
                <FootnoteText>Reg. $24.99</FootnoteText>
              ) : (
                <FootnoteLink onClick={handleOnClick} href="#matches">
                  Each match $9.99
                </FootnoteLink>
              )
            }
            isFootnoteInCard={true}
            offerCode={
              flagValue === PPV_UEFA_WCQ_FLAGS.nov_1
                ? ppvPromoCodes.ppv_uefa_early_bird
                : ppvPromoCodes.ppv_uefa_all_matches
            }
          />
        ) : null
      }
      ppvEvents={ppvEvents}
      noHeroCTA={!isFlagNoneOrLastMatch}
      isMultiPPV={ppvEvents.length > 0 && !isFlagNoneOrLastMatch}
      multiPPVTitle={
        flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? (
          <>
            Buy now and save 25% with <span className="no-wrap">MVP Access!</span>
          </>
        ) : (
          'Save 50% when you buy all matches'
        )
      }
      multiPPVBody={
        flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 && (
          <>
            Save 25% on the UEFA Pass when you buy before 11/7. <b>Only $19.99 for all matches.</b>
          </>
        )
      }
      multiPPVCTA={
        flagValue === PPV_UEFA_WCQ_FLAGS.nov_1 ? 'All matches $19.99' : 'All matches $24.99'
      }
      multiPPVOfferCode={
        flagValue === PPV_UEFA_WCQ_FLAGS.nov_1
          ? ppvPromoCodes.ppv_uefa_early_bird
          : ppvPromoCodes.ppv_uefa_all_matches
      }
      ctaText={isFlagLastMatch ? 'Buy Spain v Turkey for $9.99' : 'Get all matches'}
      isEventEnded={isFlagNone}
      heroFootnote="Fubo subscription not required"
    />
  )
}

const FootnoteText = styled.span`
  ${typographyMixin(body.md)}
  color: ${colors.white};
`
const FootnoteLink = styled.a`
  ${typographyMixin(body.md)}
  text-decoration: underline;
`

const additionalFAQs = [
  {
    question: 'Can I watch UEFA World Cup qualifiers on Fubo with Pay Per View?',
    answer:
      'Yes, many UEFA World Cup qualifying matches are available on Fubo Pay Per View. Some of them are exclusive. Matches can be bought individually, and are often available at a discount when you buy the UEFA Pass bundle.',
  },
  {
    question: 'Can I purchase individual UEFA World Cup qualifier matches on Fubo?',
    answer:
      'Yes, you can purchase individual UEFA World Cup qualifier matches or buy them in a bundle in the UEFA Pass.',
  },
  {
    question: 'What is the UEFA Pass on Fubo?',
    answer:
      'The UEFA Pass allows you to buy multiple UEFA World Cup qualifying matches on Fubo Pay Per View for one low price. Instead of buying one match, you can buy full matchdays for a discount.',
  },
  {
    question: 'Will there be commentary and analysis for the UEFA World Cup qualifiers on Fubo?',
    answer:
      'Yes, coverage, commentary and analysis for the UEFA World Cup qualifiers will be available.',
  },
  {
    question: 'Can I watch replays of the UEFA World Cup qualifiers on Fubo?',
    answer:
      'Yes, replays of each UEFA World Cup qualifying match will be available for a period of time after the match ends.',
  },
  {
    question: 'Is the Ireland v Portugal match available to watch on Fubo?',
    answer:
      'Yes, the Ireland v Portugal match is available to watch with Pay Per View on Fubo on November 13.',
  },
  {
    question: 'How can I find the Poland v Netherlands match on Fubo?',
    answer:
      'You can find the Poland v Netherlands match by searching for it in the Fubo guide or finding the Pay Per View channels in the channel guide. The match is on November 14.',
  },
  {
    question: 'Can I watch the Georgia v Spain match live on Fubo?',
    answer:
      'Yes, the November 15 Georgia v Spain match will be available for live viewing on Fubo Pay Per View.',
  },
  {
    question: 'Where can I find the Albania v England match on Fubo?',
    answer:
      'The Albania v England match on November 16 can be found in the live sports section of Fubo. You can also use the search feature to locate it quickly.',
  },
  {
    question: 'Is the Spain v Turkey match available for live streaming on Fubo?',
    answer:
      'Yes, the Spain v Turkey match is available for live streaming on Fubo. Look for it in the sports category or check the live events schedule.',
  },
]
